// extracted by mini-css-extract-plugin
export default {"feedbackBtn":"AddFeedbackBtn_feedbackBtn__IPlBg"};